import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IEmployeeObservations } from '@app/activo2/manage-vacations/manage-vacations.interface';
import {
  VacationsSeason,
  VacationsProposal,
  MotSeasonProposal
} from '@app/activo2/manage-vacations/manage-vacations.model';

@Component({
  selector: 'app-first-step',
  templateUrl: './first-step.component.html',
  styleUrls: ['./first-step.component.scss']
})
export class FirstStepComponent implements OnInit {
  @Input() seasons!: VacationsSeason[];
  @Input() proposals!: VacationsProposal;
  @Input() canEdit!: boolean;
  @Input() isMomoUser!: boolean;
  @Output() cardClicked: EventEmitter<VacationsSeason> = new EventEmitter<VacationsSeason>();
  @Output() actionClicked: EventEmitter<MotSeasonProposal> = new EventEmitter<MotSeasonProposal>();
  @Output() addProposalsClicked: EventEmitter<MotSeasonProposal> = new EventEmitter<MotSeasonProposal>();
  @Output() observationsChanged: EventEmitter<IEmployeeObservations> = new EventEmitter<IEmployeeObservations>();

  get hasData() {
    return this.proposals && this.proposals.userHasData();
  }

  ngOnInit() {
    if (!this.hasData && !this.canEdit) {
      this.proposals = new VacationsProposal({
        winter_proposals: [],
        summer_proposals: [],
        employee_observations: {
          id: 0,
          content: ''
        }
      });

      this.proposals.setSummerValues();
      this.proposals.setWinterValues();
    }
  }

  onCardClicked(season: VacationsSeason) {
    this.cardClicked.emit(season);
  }

  onActionClicked(proposal: MotSeasonProposal) {
    this.actionClicked.emit(proposal);
  }

  onAddProposalsClicked(proposal: MotSeasonProposal) {
    this.addProposalsClicked.emit(proposal);
  }

  onObservationsChanged(observations: IEmployeeObservations) {
    this.observationsChanged.emit(observations);
  }

  trackByItems(item: VacationsSeason) {
    return item;
  }
}
